var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeachers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60.001,
    viewBox: "0 0 60 60.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2450ff;}.b{fill:#6dcef8;}.c{fill:#019de5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-835 -1500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-7575.571-1521l-18.541,0v-9.073h-4.55a6,6,0,0,1-6-6v-11.238H-7614l6.514-18.465a22.883,22.883,0,0,1,8.341-11.136,22.24,22.24,0,0,1,6.037-3.034,21.726,21.726,0,0,1,6.688-1.057,21.746,21.746,0,0,1,7.665,1.4,22.16,22.16,0,0,1,7.607,4.8,23.055,23.055,0,0,1,5.054,7.189,23.675,23.675,0,0,1,2.066,8.6,23.7,23.7,0,0,1-1.328,9.071l-10.212,28.95Z",
    transform: "translate(8459 3081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7606.687-1548.942l-.181-.147a17.617,17.617,0,0,1-6.632-13.8A17.554,17.554,0,0,1-7596-1580.5a17.555,17.555,0,0,1,17.5,17.608,17.615,17.615,0,0,1-6.142,13.4l2.585,7.5a22.063,22.063,0,0,1-4.271.355A32.57,32.57,0,0,1-7606.687-1548.942Z",
    transform: "translate(8448.5 3085.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-5718.662-100.144v-9.164H-5728l6.515-18.464a23.01,23.01,0,0,1,6.217-9.427A17.6,17.6,0,0,1-5703-120.391a17.617,17.617,0,0,1-6.142,13.4l2.585,7.5a22.083,22.083,0,0,1-4.27.354A31.693,31.693,0,0,1-5718.662-100.144Z",
    transform: "translate(6573 1643)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachers);
export default __webpack_public_path__ + "static/media/teachers.623ed7f23140d1d8ab273fec1c2ef7b0.svg";
export { ForwardRef as ReactComponent };